import { Result } from "antd";
// import { BASE_PATH } from "../../api/api";
// import { calculaColor } from "../../utils/functions";

export default function RParticipante({ response, type = "asistencia" }) {
  if (!response.found) {
    return <Result status="error" title="Lo sentimos" subTitle="No encontramos al postulante" />;
  } else {
    const { data } = response;

    const messageMap = {
      carnet: "YA SE RECIBIÓ CARNET",
      asistencia: "YA SE MARCÓ ASISTENCIA"
    };

    const message = messageMap[type] || "YA SE MARCÓ ASISTENCIA";

    return (
      <div className="text-center">
        <h1
          className={
            "text-lg text-center p-1 text-white font-semibold " +
            (response.duplicado ? "bg-red-400" : "bg-green-500")
          }
        >
          {data?.nombre + " " + data?.apellido}
        </h1>
        {response.duplicado && <p className="text-sm my-2 text-red-600">{message}</p>}
        <div className="my-2">
          DNI: <span className="font-bold">{data?.nrodocumento || ""}</span> | CORRELATIVO:{" "}
          <span className="font-bold">{data?.correlativo || ""}</span>
        </div>
        {/* <img
          className="mx-auto border-8"
          style={{ borderColor: calculaColor(data?.color) }}
          src={BASE_PATH + "/v1/aux/view?filepath=fotos/" + data?.fotografia}
          width={150}
          height={180}
          alt={"fotografia de postulante " + data?.nrodocumento}
        /> */}

        <p className="text-2xl font-bold my-3 ">{data?.tipoparticipacion || ""}</p>
        <p className="text-xs text-gray-400 my-1">({data?.tipoparticipante || ""})</p>
      </div>
    );
  }
}
